import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { packagingGroup } from 'global/Models/packaging';
import ApiService from 'global/utils/ApiService';
import { setPackagingGroup, setPackagingLoading } from 'redux/reducer/packaging/packagingReducer';
import { AppDispatch } from 'redux/store';

export const getPackagingGroup = () => async (dispatch: AppDispatch) => {
  dispatch(setPackagingLoading(true));
  await ApiService.post(endpointUrls.pricingSegmentsGetAll, { recordsPerPage: 50 })
    .then((res: IBackendSearchGeneric<packagingGroup>) => {
      if (res.isSuccess) {
        const sortedData = res.data.sort((a, b) => {
          if (a.id === 50) return 1;
          if (b.id === 50) return -1;
          return 0;
        });
        dispatch(setPackagingGroup(sortedData));
      }
    })
    .catch(() => {});
  dispatch(setPackagingLoading(false));
};
